import axios from "axios";
import {logoutFromAllTabs} from "./utils/authSync";


export const BASE_URL = "/api";

const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${
    localStorage.getItem("jwtToken") || window.sessionStorage.getItem("jwtToken") || ""
  }`
});

const getRefreshToken = () =>
  localStorage.getItem("refreshToken") || window.sessionStorage.getItem("refreshToken") || "";

const maxRetries = 1;
const retryCounts = new Map();

export const handleTokenRefresh = async url => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    logoutFromAllTabs();
    return false;
  }

  try {
    const response = await axios.post(
      `${BASE_URL}/api/refresh-token`,
      {refreshToken},
      {headers: {"Content-Type": "application/json"}}
    );
    console.log("refresh....");

    const {accessToken, refreshToken: newRefreshToken} = response.data || {};
    if (accessToken && newRefreshToken) {
      localStorage.setItem("jwtToken", accessToken);
      localStorage.setItem("refreshToken", newRefreshToken);
      sessionStorage.setItem("jwtToken", accessToken);
      sessionStorage.setItem("refreshToken", newRefreshToken);
      return true;
    } else {
      throw new Error("Invalid refresh token response");
    }
  } catch (error) {
    console.error("Token refresh failed:", error.response || error);
    logoutFromAllTabs();
    return false;
  }
};

// Helper to handle API retry after refreshing token
const retryRequest = async (requestFunction, url, data) => {
  const currentRetries = retryCounts.get(url) || 0;
  if (currentRetries >= maxRetries) {
    retryCounts.delete(url);
    throw new Error("Max retry attempts reached for token refresh");
  }
  retryCounts.set(url, currentRetries + 1);

  const refreshed = await handleTokenRefresh(url);
  if (!refreshed) {
    throw new Error("Token refresh failed");
  }

  const result = await requestFunction(url, data);
  retryCounts.delete(url);
  return result;
};

export const GET = async url => {
  try {
    return await axios.get(`${BASE_URL}/${url}`, {
      headers: getHeaders(),
      withCredentials: true
    });
  } catch (error) {
    console.log(error.toJSON());
    if (error.response?.status === 401) {
      return retryRequest(GET, url);
    }
    throw error;
  }
};

export const POST = async (url, data) => {
  try {
    return await axios(`${BASE_URL}/${url}`, {
      method: "POST",
      headers: getHeaders(),
      data,
      withCredentials: true
    });
  } catch (error) {
    console.log(error.toJSON());
    if (error.response?.status === 401) {
      return retryRequest(POST, url, data);
    }
    throw error;
  }
};

export const PATCH = async (url, data) => {
  try {
    return await axios(`${BASE_URL}/${url}`, {
      method: "PATCH",
      headers: getHeaders(),
      data,
      withCredentials: true
    });
  } catch (error) {
    console.log(error.toJSON());
    if (error.response?.status === 401) {
      return retryRequest(PATCH, url, data);
    }
    throw error;
  }
};

export const PUT = async (url, data) => {
  try {
    return await axios(`${BASE_URL}/${url}`, {
      method: "PUT",
      headers: getHeaders(),
      data,
      withCredentials: true
    });
  } catch (error) {
    console.log(error.toJSON());
    if (error.response?.status === 401) {
      return retryRequest(PUT, url, data);
    }
    throw error;
  }
};

export const DELETE = async (url, data) => {
  try {
    return await axios(`${BASE_URL}/${url}`, {
      method: "DELETE",
      headers: getHeaders(),
      data,
      withCredentials: true
    });
  } catch (error) {
    console.log(error.toJSON());
    if (error.response?.status === 401) {
      return retryRequest(DELETE, url, data);
    }
    throw error;
  }
};
